import React from "react";
import { useRef, useEffect } from "react";
import useState from "react-usestateref";
import { useDispatch } from "react-redux";
import { settings } from "imagica-corekit/dist/base/kernel/Settings";
import style from "./css/AISaas.module.css";
import { useSelector } from "react-redux";
import { Input, Modal } from "antd";
import { UpOutlined } from "@ant-design/icons";
import ContentFrame from "../ContentFrame";
import SharesBuy from "../components/SharesBuy";
import func from "@uikit/func";
import { fotActions } from "../../store/fot";
import LoadingOutline from "../components/LoadingOutline";
import { editorActions } from "../../store/editor";
import useScrollToLatest from "../../custom-hooks/useScrollToLatest";
import { isEmpty } from "lodash";
import ToSignUpView from "../../uiview/views/toSignUp/ToSignUpView";
import { ToSignUpViewBloc } from "../../uiview/views/toSignUp/ToSignUpViewBloc";
import AISaasTitle from "./AISaasTitle/Index";
import { AiSaasOutputList } from "../../uiview/views/AISaasOutput";
import { useHomeUsePluginContainer } from "@custom-hooks/HomeUsePluginRoot";
import { PreviewTitle } from "../components/PreviewTitle";
import { WEB_APP_DEFAULT_SUBTITLE, WEB_APP_DEFAULT_TITLE } from "./constants";
import { isOnlyChatInterface } from "./util";
import CustomHover from "@views/components/CustomHover";
import { Nodes } from "@uiview/views/Nodes/Nodes";
import { get } from "lodash";
import useFeatureTags from "@custom-hooks/useFeatureTags";
import { setThemeProperty } from "@custom-hooks/useSaasTheme";
import { logEvent } from "@uikit/service/amplitude";
import { getLocalShareQ, isShareWebApp } from "@uikit/util/UrlUtil";

const count = 30;
const colorData = {
  light: {
    color: "#12192B",
    inputBoxBgc: "#fff",
    enterBgc: "rgba(2, 12, 38, 0.05)",
    footerBrainStudiosColor: "rgba(18, 25, 43, 0.65)",
    topSuctionBgc: "rgba(255, 255, 255, 0.65)",

    submitButtonColor: "#ffffff",
    submitButtonBgClr: "#12192B",

    homeIconBgc: "#fff",
    iconBackdropFilter: "none",
    topRightNumberCorlor: "#12192B",
    botIndexBg: "rgba(10, 157, 255, 0.25)",
    askLinkBorder: "rgba(2, 12, 38, 0.05)",
    inputTitleColor: "#020C26",
    saasTitleDisableColor: "#000",
  },
  dark: {
    color: "#FFFFFF",
    inputBoxBgc: "rgba(255, 255, 255, 0.1)",
    enterBgc: "rgba(255, 255, 255, 0.1)",
    footerBrainStudiosColor: "rgba(255, 255, 255, 0.65)",
    topSuctionBgc: "rgba(255, 255, 255, 0.1)",
    submitButtonColor: "#12192B",
    submitButtonBgClr: "#ffffff",

    homeIconBgc: "rgba(255, 255, 255, 0.10)",
    iconBackdropFilter: "blur(80px)",
    topRightNumberCorlor: "#12192B",
    botIndexBg: "rgb(10, 157, 255)",
    askLinkBorder: "rgba(255, 255, 255, 0.3)",
    inputTitleColor: "#fff",
    saasTitleDisableColor: "rgba(255, 255, 255, 0.3)",
  },
};

function AISaas(props, ref) {
  const dispatch = useDispatch();
  const outputListRef = useRef(null);
  const signalRef = useRef(null);
  const contentRef = useRef(null);
  const inputBoxRef = useRef(null);
  const aiSaasContentRef = useRef(null);
  const rollBox = useRef(null);
  const scrollBox = useRef(null);
  const inputTextArea = useRef(null);
  const editPlaceholderRef = useRef(null);
  const clickTimeout = useRef(null);
  // const inputTextArea = useRef(null);
  const btnRef = useRef(null);
  const inputListRef = useRef([]);
  const isAutoScroll = useRef(false);
  const timer = useRef(null);

  const { setDisplayThought } = useHomeUsePluginContainer();
  const featureTags = useFeatureTags();

  const [showEditPlaceholder, setShowEditPlaceholder] = useState(false);
  // const [cursorStatus, setCursorStatus] = useState({})
  const [showBottomPrompt, setShowBottomPrompt] = useState(false);
  const [showTopSuction, setShowTopSuction, showTopSuctionRef] = useState(false);
  const [showOutPut, setShowsOutPut, showOutPutRef] = useState(false);
  const [changeInputText, setChangeInputText] = useState(false);
  const [noScroll, setNoScroll] = useState(false);

  const [isFoucs, setIsFoucs] = useState({});
  const [placeholderInput, setPlaceholderInput] = useState("");
  const [placeholderInputId, setPlaceholderInputId] = useState("");
  const [inputTitle, setInputTitle] = useState("");
  const [inputTitleId, setModifyInputTitleId] = useState("");
  const [showInputTitleId, setShowInputTitleId] = useState("");
  const [onMouseInputId, setOnMouseInputId] = useState("");
  const [editInputId, setEditInputId] = useState("");

  const [editPlaceholderData, setEditPlaceholderData] = useState({});

  const [btnText, setBtnText] = useState("Submit");
  const [scrollTopNum, setScrollTopNum, scrollTopNumRef] = useState(0);

  const selectedTemplate = useSelector(state => state.studio.selectedTemplate);
  const editorIdArr = useSelector(state => state.fot.editorIdArr);
  const locusEditorId = useSelector(state => state.fot.locusEditorId);
  const applicationTheme = useSelector(state => state.editor.applicationTheme);

  const isStaticMode = useSelector(state => state.editor.isStaticMode);
  const setIsStaticMode = val => {
    dispatch(editorActions.setIsStaticMode(val));
  };

  const setApplicationTheme = val => {
    dispatch(editorActions.setApplicationTheme(val));
  };
  const isDarkMode = applicationTheme === "dark";

  const login = {
    light: `${settings.S3CDN}${settings.viewAssetsPath}Vector@2x.png`,
    dark: `${settings.S3CDN}${settings.viewAssetsPath}darkModeLogo2x.png`,
  };

  const toSignUpViewBloc = new ToSignUpViewBloc();

  const setHighlightData = val => {
    dispatch(fotActions.setHighlightData(val));
  };

  const isMobile = window.navigator.userAgent.includes("Mobile");

  useScrollToLatest({
    scrollWrapperRef: contentRef,
    scrollList: props.saasUIListData,
    selector: ".ContentFrame",
    enableScrollToImage: true,
    noNeedScroll: props.isShare || noScroll,
  });

  const onSaasInputChange = (e, nodeId) => {
    setChangeInputText(true);
    const newInput = props.saasUIInputData.map(x => {
      if (x.id === nodeId) {
        return {
          ...x,
          data: {
            ...x.data,
            textAreaValue: e.target.value,
          },
        };
      }
      return x;
    });
    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newInput,
      };
    });
  };

  const openEditPlaceholder = x => {
    setPlaceholderInputId(x.id);
    setPlaceholderInput(x?.data?.webPlaceholder || props.saasUIData?.placeholder);
    setShowEditPlaceholder(true);
  };

  const handleEditplaceholderChange = e => {
    setPlaceholderInput(e.target.value);
  };

  const handleModalCancel = () => {
    setPlaceholderInput("");
    setShowEditPlaceholder(false);
  };

  const handleModalOk = () => {
    const inputArr = props.saasUIData?.input || [];

    const newInputArr = inputArr.map(i => {
      if (i.id === placeholderInputId) {
        return {
          ...i,
          data: Object.assign({}, i.data, { webPlaceholder: placeholderInput }),
        };
      }
      return i;
    });
    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newInputArr,
      };
    });
    handleModalCancel();
  };

  const clickBrainStudios = () => {
    // window.open(`${window.location.origin}${window.location.pathname}#/editor`, 'target')
    logEvent("click_imagica_home", {
      project_static_id: getLocalShareQ(),
      source: isShareWebApp() ? "webapp" : "preview",
    });
    window.open("https://create.imagica.ai", "target");
    if (func.isEmpty(contentRef.current)) return;
    contentRef.current.removeEventListener("scroll", setTopSuction, false);
  };

  const onMouseOver = nodeId => {
    const obj = {
      nodeId,
    };
    setHighlightData(obj);
  };

  const onMouseLeave = () => {
    setHighlightData({});
  };

  const scrollToTop = () => {
    const element = contentRef.current;
    if (isEmpty(element) || element.scrollTop === 0) {
      isAutoScroll.current = false;
      return;
    }

    element.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const resetInput = () => {
    const newInput = props.saasUIInputData.map(x => {
      return {
        ...x,
        data: {
          ...x.data,
          textAreaValue: "",
        },
      };
    });
    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newInput,
      };
    });
  };

  const clickTopRightNumber = () => {
    const inputPosition = getButtomScrollTop();
    setShowTopSuction(true);
    setShowsOutPut(true);
    setScrollTopNum(inputPosition);
    isAutoScroll.current = true;
    if (!isEmpty(contentRef.current)) contentRef.current.scrollTop = inputPosition;
  };

  const clickArrow = () => {
    // setShowsOutPut(false)
    // setShowTopSuction(true)
    // isAutoScroll.current = false
    // setScrollTopNum(contentRef.current.scrollTop)
    if (!isEmpty(contentRef.current)) {
      const distance = props.runAllLoading ? 70 : 0;
      contentRef.current.scrollTop = signalRef.current.offsetTop - distance;
      setScrollTopNum(contentRef.current.scrollTop);
    }
  };
  const inputBlur = (nodeId, index) => {
    setEditInputId("");
    setTimeout(() => {
      // setCursorStatus(prev => {
      //   return {
      //     ...prev,
      //     [nodeId]: false
      //   }
      // })
      setIsFoucs(prev => {
        return {
          ...prev,
          [nodeId]: false,
        };
      });
      // const scrollTop = contentRef.current.scrollTop
      // const whetherToScroll = scrollTop > 480
      // setShowTopSuction(whetherToScroll)

      const inputRef = inputListRef.current[index]?.refValue?.resizableTextArea?.textArea;
      // 失去焦点重置 input 高度
      if (props.isShare && !func.isEmpty(inputRef) && func.isEmpty(inputRef.value)) {
        inputRef.style.height = inputRef.style.minHeight;
      }
    }, 200);
  };

  const inputTopFocus = (nodeId, index) => {
    if ((isMobile || !props.isShare) && !showOutPut) {
      // isAutoScroll.current = true
      // const element = inputBoxRef.current
      // if(isEmpty(element)) return;
      // element.scrollIntoView(true)
      // const currentInput = inputListRef.current[0];
      // currentInput?.refValue && currentInput.refValue.focus({
      //   cursor: 'end'
      // })
      // setShowsOutPut(true)
      // setShowTopSuction(true)
      clickTopRightNumber();
      const currentInput = inputListRef.current[0];
      currentInput?.refValue &&
        currentInput.refValue.focus({
          cursor: "end",
        });
    }
  };

  const inputFocus = (nodeId, index) => {
    if (isMobile && props.isShare && !showOutPut) {
      calcScrollDistanceTop();
    }
    // setCursorStatus(prev => {
    //   return {
    //     ...prev,
    //     [nodeId]: true
    //   }
    // })
    const foucsObj = {};
    props.saasUIInputData.forEach(x => {
      foucsObj[x.id] = x.id === nodeId;
    });
    setIsFoucs(foucsObj);

    if (showOutPut && showTopSuction && props.saasUIInputData?.length === 1) {
      clickTopRightNumber();
    }

    if (props.isShare) {
      const inputRef = inputListRef.current[index]?.refValue?.resizableTextArea?.textArea;
      let indexPlaceholder = props.saasUIInputData.find(x => x.id === nodeId)?.data?.placeholder;
      if (indexPlaceholder === "Enter input") {
        indexPlaceholder = props.saasUIData?.placeholder;
      }
      // 改变 input 高度 && placeholder 没有截断 不改变高度。
      if (!func.isEmpty(inputRef) && func.isEmpty(inputRef.value) && indexPlaceholder !== inputRef.placeholder) {
        inputRef.style.height = "auto";
      }
    }
    // setShowTopSuction(false)
  };
  const handleSuspensionInput = () => {
    // 已经置顶，不处理
    if (showTopSuctionRef.current) return;
    //有button时使用button, 没有button时使用最后一个input
    let element = btnRef.current;
    if (props.saasUIInputData?.length === 1) {
      const input = props.saasUIInputData[0];
      const inputRef = inputListRef.current.find(ref => ref.refKey === input?.id);
      element = inputRef?.refValue?.resizableTextArea?.textArea;
    }
    if (isEmpty(contentRef.current) || isEmpty(element)) return;
    const btnOrInputTop = element.getBoundingClientRect()?.top;
    const viewTop = contentRef.current.getBoundingClientRect()?.top;
    const isBottom =
      contentRef.current.scrollHeight > contentRef.current.clientHeight &&
      contentRef.current.scrollTop + 2 >= contentRef.current.scrollHeight - contentRef.current.clientHeight;
    //按钮或者只有一个input时的输入框在顶部被遮挡部分时 || 有滚动条时滚动到页面底部，输入框置顶，不显示title
    // if(btnOrInputTop < viewTop || isBottom){
    //   blurInput()
    //   changeStatus()
    // }
  };

  const setTopSuction = () => {
    setScrollBoxPositioning();
    const toUp = contentRef.current.scrollTop <= scrollTopNumRef.current;
    const contentDistance = props.saasUIInputData.length === 1 ? 40 : props.isShare ? 97 : 70;
    if (scrollTopNumRef.current < inputBoxRef.current.offsetTop - 50) {
      // 在标题区域上方的时候隐藏导航
      setShowsOutPut(false);
      setShowTopSuction(false);
      setScrollTopNum(contentRef.current.scrollTop);
      return;
    } else if (scrollTopNumRef.current < signalRef.current.offsetTop - contentDistance) {
      // 在input区域的时候
      if (isAutoScroll.current === true) {
        // 点击折叠按钮滑动到input区域不需要隐藏
        setScrollTopNum(contentRef.current.scrollTop);
        return;
      } else {
        // 自主滑动到input区域需要隐藏
        setShowsOutPut(false);
        setShowTopSuction(false);
        isAutoScroll.current = false;
        setScrollTopNum(contentRef.current.scrollTop);
        return;
      }
    } else {
      // 自主滑动到output区域不需要隐藏
      setShowsOutPut(false);
      setShowTopSuction(true);
      isAutoScroll.current = false;
      setScrollTopNum(contentRef.current.scrollTop);
      return;
    }
    // clearTimeout(timer.current);
    // //结束滚动, 有时候滚动结束scrollTop不为0，也不和上一次top值相同。使用时间来判定
    // timer.current = setTimeout(function () {
    //   if(isAutoScroll.current) {
    //     isAutoScroll.current = false
    //   }
    // }, 100)
    // //结束滚动
    // if(isAutoScroll.current && contentRef.current.scrollTop === 0) {
    //   isAutoScroll.current = false
    // }
    // //回到首页，自动滚动时，不监听滚动条事件
    // if(isAutoScroll.current) return;

    // if(showOutPutRef.current && contentRef.current.scrollTop !== scrollTopNumRef.current) blurInput()
    // setScrollTopNum(contentRef.current.scrollTop)

    // handleSuspensionInput()

    // //滚动条高度超过80就设置showTopSuction为true,再次滑动到顶部也不变。点击气泡或者小房子后再次重置showTopSuction为false
    // if(showTopSuctionRef.current || !showOutPutRef.current || isEmpty(contentRef.current) || toUp || isMobile || !props.isShare) return;

    // // 输入框聚焦状态下不改变大小
    // // if(inputTextArea.current?.resizableTextArea?.textArea === document.activeElement) return;

    // const whetherToScroll = contentRef.current.scrollTop > 80
    // whetherToScroll && setShowTopSuction(whetherToScroll)
  };

  const setScrollBoxPositioning = () => {
    if (
      document.body.scrollWidth < 600 ||
      !props.isShare ||
      contentRef.current.offsetHeight === contentRef.current.scrollHeight
    )
      return;
    setScrollbarHeight();
    // 显示高度/总高度=bar高度/scroll高度
    const scrollHeight = document.body.scrollHeight - 200;
    const height = (scrollHeight * contentRef.current.offsetHeight) / contentRef.current.scrollHeight;
    scrollBox.current.style.height = `${height}px`;

    const scrollTop =
      (contentRef.current.scrollTop / (contentRef.current.scrollHeight - contentRef.current.offsetHeight)) *
      (scrollHeight - height);
    scrollBox.current.style.top = `${scrollTop}px`;
  };

  const setScrollbarHeight = () => {
    if (!props.isShare) return;
    const screenHeight = document.body.scrollHeight;
    rollBox.current.style.height = `${screenHeight - 200}px`;
    rollBox.current.style.marginLeft = `${outputListRef.current.scrollWidth}px`;
  };

  const calcScrollDistanceTop = () => {
    const screenHeight = document.body.scrollHeight;
    const element = inputBoxRef.current;
    // 目前存在多个 input 高度计算 确保高度正确
    const scrollHeight = element?.scrollHeight || 200;
    outputListRef.current.style.minHeight = `${screenHeight - scrollHeight}px`;
    outputListRef.current.style.height = `${screenHeight - scrollHeight}px`;

    setTimeout(() => {
      if (isEmpty(element)) return;
      element.scrollIntoView(false);
      // 聚焦
    }, 300);

    // let inputBoxPositioning = contentRef.current.scrollHeight - screenHeight;
    // if (screenHeight < outputListRef.current.offsetHeight) {
    //   inputBoxPositioning =
    //     contentRef.current.scrollHeight -
    //     outputListRef.current.scrollHeight -
    //     165;
    // }
    // let myTimer = null;
    // // 内容滚动条当前高度
    // let scrollTo = contentRef.current.scrollTop;
    // // 滚动到底部
    // if (util.isEmpty(myTimer)) {
    //   myTimer = setInterval(() => {
    //     scrollTo += 50;
    //     if (scrollTo > inputBoxPositioning) {
    //       scrollTo = inputBoxPositioning;
    //       window.clearInterval(myTimer);
    //       myTimer = null;
    //     }
    //     contentRef.current.scrollTop = scrollTo;
    //   }, 10);
    // }
  };

  // const clickCreateContent = async (e) => {
  //   e.preventDefault();
  //   e.target.blur()
  //   if(!isMobile && props.isShare) {
  //     setCursorStatus(true)
  //     calcScrollDistanceTop()
  //   }
  //   await props.clickCreateContent(props.saasUIInputData.id, props.saasUIInputData.data.textAreaValue, 'saas')
  //   setShowBottomPrompt(false)
  // }
  const disableButton = () => {
    const disableUpdate = btnText === "Update" && !changeInputText;
    return hasEmptyInput() || disableUpdate || isStaticMode;
  };
  const hasEmptyInput = () => {
    return props.saasUIInputData.some(x => isEmpty(x?.data?.textAreaValue));
  };

  const blurInput = () => {
    const active = document.activeElement;
    if (active.nodeName === "TEXTAREA") {
      active?.blur();
    }
    const foucsObj = {};
    props.saasUIInputData.forEach(x => {
      foucsObj[x.id] = false;
    });
    setIsFoucs(foucsObj);
  };

  const clickSubmit = async e => {
    if (disableButton()) return;

    if (hasEmptyInput()) {
      func.customMsg({
        content: "Need to input something",
        type: "warning",
      });
      return;
    }
    // e.preventDefault();
    //使输入框失去焦点
    blurInput();
    // loading不可点击
    if (props.runAllLoading) return;

    setContentBoxMinHeight();
    // 滚动动画及修改状态
    calcTitleHideScroll();

    // e.target.blur()
    // if(!isMobile && props.isShare) {
    // const obj = {}
    // const foucsObj = {}
    // props.saasUIInputData.forEach(x => {
    // obj[x.id] = true
    // foucsObj[x.id] = false
    // })
    // setCursorStatus(obj)
    // setIsFoucs(foucsObj)
    // calcScrollDistanceTop()
    // }
    setNoScroll(true);
    await props.clickCreateContent("saas");
    setNoScroll(false);
    setShowBottomPrompt(false);
  };

  const setContentBoxMinHeight = () => {
    const screenHeight = aiSaasContentRef.current.clientHeight;
    outputListRef.current.style.minHeight = `${screenHeight - 20}px`;
    outputListRef.current.style.height = `${screenHeight - 20}px`;
  };

  // const resetContentBoxMinHeight = () => {
  //   const screenHeight = document.body.scrollHeight;
  //   outputListRef.current.style.minHeight = '100px';
  //   outputListRef.current.style.height = 'auto';
  // }

  const changeStatus = () => {
    setShowsOutPut(false);
    setShowTopSuction(true);
    setBtnText("Update");
    setChangeInputText(false);
    // setTimeout(() => {
    //   if(!isEmpty(contentRef.current) && contentRef.current.scrollHeight > contentRef.current.clientHeight) {
    //     contentRef.current.scrollTop = 0
    //   }
    // }, 200)
  };

  const calcTitleHideScroll = () => {
    // const needScrollLength = (inputBoxRef.current?.offsetTop || 230) - 30
    setTimeout(() => {
      setShowsOutPut(false);
      setShowTopSuction(true);
      const distance = props.saasUIInputData.length === 1 ? 0 : 70;
      const needScrollLength = signalRef.current.offsetTop - distance;
      contentRef.current.scrollTop = needScrollLength;

      contentRef.current.scrollTo({
        top: needScrollLength,
        behavior: "smooth",
      });
      setScrollTopNum(needScrollLength);
    }, 800);
    // const perMove = needScrollLength / count
    // let myTimer = null
    // 滚动到底部
    // if (util.isEmpty(myTimer)) {
    //   myTimer = setInterval(() => {
    //     const scorllLen = contentRef.current.scrollHeight - contentRef.current.clientHeight
    //     if(contentRef.current.scrollTop + 2 >= needScrollLength || contentRef.current.scrollTop + 2 >= scorllLen){
    //       clearInterval(myTimer)
    //       myTimer = null
    //       changeStatus()
    //       setScrollTopNum(contentRef.current.scrollTop)
    //       return;
    //     }
    //     contentRef.current.scrollTop += perMove;

    //   }, 10);
    // }
  };

  const clickCloseContent = (e, nodeId) => {
    if (isStaticMode) return;
    e.preventDefault();
    //在收起状态：点击x按钮，清空所有input的内容，并且展开所有输入框
    if (showTopSuction) {
      resetInput();
      clickTopRightNumber();
    } else {
      //在展开状态，点击x按钮，只清空当前的输入。
      e.target.value = "";
      onSaasInputChange(e, nodeId);
    }
  };

  const hideAndDisplay = key => {
    return key ? style["display-box"] : style["hide-box"];
  };

  const onInputTitleEnter = (e, nodeId) => {
    e?.stopPropagation();
    e?.preventDefault();

    const newInput = props.saasUIInputData.map(x => {
      if (x.id === nodeId) {
        return {
          ...x,
          data: {
            ...x.data,
            inputTitle: inputTitle?.trim(),
          },
        };
      }
      return x;
    });

    // 更新 input title
    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newInput,
      };
    });

    setModifyInputTitleId("");
    setInputTitle("");
    setShowInputTitleId("");
  };

  const onClickInputTitleClose = (e, nodeId) => {
    if (isStaticMode) return;
    e?.stopPropagation();
    const newInput = props.saasUIInputData.map(x => {
      if (x.id === nodeId) {
        return {
          ...x,
          data: {
            ...x.data,
            inputTitle: "",
          },
        };
      }
      return x;
    });

    // 更新 input title
    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newInput,
      };
    });

    setModifyInputTitleId("");
    setInputTitle("");
    setShowInputTitleId("");
  };

  const clickInputTitle = (e, x) => {
    if (isStaticMode) return;
    // 默认重置
    const dataTitle = x?.data?.inputTitle || "";
    e?.stopPropagation();
    e?.preventDefault();
    // 输入后 点击不重置
    if (props.isShare || showOutPut) {
      return;
    }

    setModifyInputTitleId(x.id);
    setInputTitle(dataTitle);
  };

  const getBorder = show => {
    return show ? style["input-title-border"] : "";
  };

  const onMouseLeaveBox = () => {
    setOnMouseInputId("");
  };

  const isEditPlaceholder = id => {
    return !func.isEmpty(editPlaceholderData) && editPlaceholderData.id === id;
  };
  const onMouseOverBox = id => {
    if (editInputId === id || isEditPlaceholder(id)) return;
    setOnMouseInputId(id);
  };
  const deleteInput = (e, id) => {
    if (isStaticMode) return;
    e?.stopPropagation();
    e?.preventDefault();
    const newInput = props.saasUIInputData.filter(x => x.id != id);

    // 删除 input
    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newInput,
      };
    });

    props.closeInputId(id);
  };

  const clickEditPlaceholder = () => {
    editPlaceholderRef?.current?.focus({
      cursor: "end",
    });
  };

  const getByPlaceholderText = (x, index) => {
    // 默认 Enter something
    let placeholderText = props.saasUIData?.placeholder || "";

    // placeholder 不是默认值。
    if (!func.isEmpty(x?.data?.placeholder) && x?.data?.placeholder != "Enter input") {
      placeholderText = x?.data?.placeholder;
    }

    // 分享页显示 placeholder
    if (props.isShare) {
      // 选中/编辑状态不往下执行
      if (!func.isEmpty(isFoucs) && isFoucs[x.id]) return placeholderText;

      const inputRef = inputListRef.current[index]?.refValue?.resizableTextArea?.textArea;

      // 减去 input padding 22px
      const scrollWidth = inputRef?.scrollWidth - 22 || 210;
      const byteProportion = 11;
      const byteNum = Math.floor(scrollWidth / byteProportion);

      // 内容大于最宽字符换行
      const isOmit = placeholderText.length > byteNum;

      // 大于最宽字符换行
      if (isOmit) {
        return `${placeholderText.substr(0, byteNum)}...`;
      }
      // 小于显示完整字符
      return placeholderText;
    }
    // placeholder 字符串小于 18 不显示省略号
    if (placeholderText.length <= 18) return placeholderText;
    // placeholder 文本过多，只显示一行。
    return `${placeholderText.substr(0, 18)}...`;
  };

  // 暂时屏蔽双击编辑 Placeholder，等产品确认新的流程
  // const handleClicks = (e, data) => {
  //   // 修改 Placeholder
  //   if(!util.isEmpty(editPlaceholderData)) return;
  //   if (clickTimeout.current !== null) {
  //     // 双击
  //     doubleClickEditInputPlaceholder(e, data)
  //     clearTimeout(clickTimeout.current)
  //     clickTimeout.current = null
  //     setTimeout(() => {
  //       clickEditPlaceholder()
  //     }, 300)
  //   } else {
  //     clickTimeout.current = setTimeout(( )=> {
  //       // 单击
  //       clickEditInputId(e, data.id)
  //       clearTimeout(clickTimeout.current)
  //       clickTimeout.current = null
  //     }, 300)
  //   }
  // }

  const getButtomScrollTop = () => {
    const element = inputBoxRef.current;
    if (isEmpty(element)) return 300;
    return element.offsetTop - 30 || 300;
  };

  const clickEditInputId = (e, id) => {
    if (isStaticMode) return;
    e?.stopPropagation();
    e?.preventDefault();

    if (isEditPlaceholder(id)) {
      placeholderBlurEnter();
      return;
    }
    setTimeout(() => {
      setEditInputId(id);
      const currentInput = inputListRef.current.find(x => x.refKey === id);
      currentInput?.refValue &&
        currentInput.refValue.focus({
          cursor: "end",
        });
    }, 300);
  };

  const doubleClickEditInputPlaceholder = (e, data) => {
    e.stopPropagation();
    e.preventDefault();
    const newEditPlaceholderData = {
      id: data?.id,
      placeholder: data?.data?.webPlaceholder || data?.data?.placeholder,
    };
    setEditPlaceholderData(newEditPlaceholderData);
  };

  const onSaasPlaceholderChange = e => {
    const placeholderData = Object.assign({}, { ...editPlaceholderData }, { placeholder: e?.target?.value });
    setEditPlaceholderData(placeholderData);
  };
  const placeholderBlurClean = () => {
    setTimeout(() => {
      setEditPlaceholderData({});
    }, 300);
  };

  const placeholderBlurEnter = () => {
    const newInput = props.saasUIInputData.map(x => {
      if (isEditPlaceholder(x.id)) {
        return {
          ...x,
          data: {
            ...x.data,
            webPlaceholder: editPlaceholderData.placeholder,
          },
        };
      }
      return x;
    });

    // 更新 input placeholder
    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        input: newInput,
      };
    });

    placeholderBlurClean();
  };

  const onSaasInputTitleChange = (e, id) => {
    setModifyInputTitleId(id);
    setInputTitle(e.target.value);
  };

  const onInputTitleBlur = () => {
    setModifyInputTitleId("");
  };

  const onInputTitleMouseLeave = () => {
    if (props.isShare) return;
    setShowInputTitleId("");
  };

  const onInputTitleMouseOver = id => {
    if (props.isShare || showOutPut) return;
    setShowInputTitleId(id);
  };

  const onInputEnter = (e, nodeId) => {
    e.preventDefault();
    const emptyNode = props.saasUIInputData.find(x => isEmpty(x?.data?.textAreaValue));
    //input都有值，点击submit
    if (isEmpty(emptyNode)) {
      clickSubmit();
      return;
    }
    //聚焦到空的input
    setTimeout(() => {
      const currentInput = inputListRef.current.find(x => x.refKey === emptyNode.id);
      currentInput && currentInput?.refValue?.focus();
    }, 300);
  };

  useEffect(() => {
    const theme = props?.saasUIData?.theme;
    // setSaasTitleStyle(props.saasUIData?.titleStyle)

    if (!func.isEmpty(theme)) {
      setApplicationTheme(theme);
    }
    setIsStaticMode(props?.saasUIData?.staticMode || false);
    setShowBottomPrompt(true);
    setTimeout(() => {
      if (!isEmpty(contentRef.current)) contentRef.current.scrollTop = 200;
    }, 200);

    if (props.isShare) return;

    props.setSaasUIData(prevData => {
      return {
        ...prevData,
        title: prevData.title || selectedTemplate.template_name || WEB_APP_DEFAULT_TITLE,
        subTitle: prevData.subTitle || WEB_APP_DEFAULT_SUBTITLE,
      };
    });
    // const obj = {}
    const foucsObj = {};
    props.saasUIInputData.forEach(x => {
      // obj[x.id] = false
      foucsObj[x.id] = false;
    });
    // setCursorStatus(obj)
    setIsFoucs(foucsObj);
  }, []);

  /**
   * Preview 1.5 重构后，这里代码会移除
   * 主题切换会提升到preview层控制
   */
  useEffect(() => {
    if (!func.isEmpty(applicationTheme) && contentRef?.current) {
      setThemeProperty(contentRef.current, applicationTheme);
    }
  }, [applicationTheme, contentRef]);

  useEffect(() => {
    if (!isEmpty(props.saasUIListData) && !isEmpty(props.saasUIInputData) && !isEmpty(contentRef.current)) {
      // 有数据后开启滚动监听
      contentRef.current?.addEventListener("scroll", setTopSuction, false);
    }
    return () => {
      contentRef.current?.removeEventListener("scroll", setTopSuction, false);
    };
  }, [props.saasUIListData, props.saasUIInputData]);

  useEffect(() => {
    if (!isEmpty(props.saasUIListData)) {
      setTimeout(() => {
        setScrollBoxPositioning();
      }, 1000);
    }

    if (isEmpty(outputListRef.current) || props.runAllLoading) {
      setShowBottomPrompt(true);
      return;
    }
    if (
      outputListRef.current.scrollHeight > outputListRef.current.offsetHeight ||
      outputListRef.current.offsetHeight > contentRef.current.offsetHeight - 150
    ) {
      setShowBottomPrompt(false);
      return;
    }
    if (outputListRef.current.scrollHeight === outputListRef.current.offsetHeight) {
      setShowBottomPrompt(true);
    }
  }, [props.saasUIListData]);

  const thoughtOptions = isOnlyChatInterface(props.saasUIData?.output)
    ? props.saasUIData.output
    : !props.saasUIData.staticMode
    ? props.saasUIListData
    : props.saasUIData.output;

  return (
    <div className={style["ai-saas"]} ref={aiSaasContentRef}>
      {showTopSuction && (
        <div className={`${style["output-top"]} ${!showTopSuction ? style["output-index"] : ""}`}>
          {/* 吸顶中间输入框 */}
          {!func.isEmpty(props.saasUIInputData) && !showOutPut ? (
            <div
              className={`${style["saas-input-content"]} ${style["reduce-width"]} ${style["top-margin"]} ${style["show-output"]}`}
            >
              {props.saasUIInputData.slice(0, 1).map((x, index) => {
                return (
                  <div key={x.id}>
                    <div
                      className={style["transparent-storey"]}
                      onMouseLeave={onMouseLeaveBox}
                      onMouseOver={() => onMouseOverBox(x.id)}
                    >
                      <div
                        className={`${
                          style[!props.isShare ? "input-box-default-padding" : "input-box-reset-padding"]
                        } ${style["input-box"]} ${isFoucs[x.id] ? style["enlarge-input-box"] : ""} ${
                          style["top-suction"]
                        } ${isEditPlaceholder(x.id) && style["convention-padding"]}`}
                      >
                        {!props.isShare && !showTopSuction && (
                          <div
                            className={`${onMouseInputId === x.id ? style["hover-border"] : ""} ${
                              editInputId === x.id ? style["disappears"] : ""
                            } ${isEditPlaceholder(x.id) ? style["hover-border"] : ""}
                            `}
                            onClick={e => clickEditInputId(e, x.id)}
                          >
                            {x.id === onMouseInputId && (
                              <div className={style["right-box"]}>
                                <div className={style["right-box-menu"]}>
                                  <div className={style["icon-button"]} onClick={e => clickEditInputId(e, x.id)}>
                                    <img src={`${settings.S3CDN}${settings.viewAssetsPath}checkMarkBlack.png`}></img>
                                  </div>
                                  <div className={style["icon-button"]} onClick={e => deleteInput(e, x.id)}>
                                    <img src={`${settings.S3CDN}${settings.viewAssetsPath}previewDelete2x.png`}></img>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        )}

                        <Input.TextArea
                          ref={r =>
                            (inputListRef.current[index] = {
                              refKey: x.id,
                              refValue: r,
                            })
                          }
                          // ref={index === 0 ? inputTextArea : undefined}
                          placeholder={getByPlaceholderText(x, index)}
                          className={`${style["saas-input"]} ${isEditPlaceholder(x.id) && style["disappears"]}`}
                          autoSize={{ minRows: 1, maxRows: 10 }}
                          bordered={false}
                          value={x?.data?.textAreaValue}
                          onChange={e => onSaasInputChange(e, x.id)}
                          // allowClear
                          onMouseLeave={onMouseLeave}
                          onMouseOver={() => onMouseOver(x.id)}
                          // onPressEnter={(e) => e.preventDefault()}
                          onPressEnter={e => onInputEnter(e, x.id)}
                          onBlur={() => inputBlur(x.id, index)}
                          onFocus={() => inputTopFocus(x.id, index)}
                        />
                        {isEditPlaceholder(x.id) && (
                          <Input.TextArea
                            ref={editPlaceholderRef}
                            placeholder={editPlaceholderData?.placeholder}
                            className={`${style["saas-placeholder"]} ${style["saas-input"]}`}
                            autoSize={{ minRows: 1, maxRows: 10 }}
                            bordered={false}
                            value={editPlaceholderData?.placeholder}
                            onChange={onSaasPlaceholderChange}
                            onPressEnter={placeholderBlurEnter}
                            onBlur={() => placeholderBlurClean()}
                          />
                        )}
                        {/* <Input.TextArea
                          ref={inputTextArea}
                          placeholder={props.saasUIData.placeholder}
                          className={style['saas-input']}
                          autoSize={{ minRows: 1, maxRows: 10 }}
                          bordered={false}
                          value={props.saasUIInputData.data.textAreaValue}
                          onChange={onSaasInputChange}
                          // allowClear
                          onMouseLeave={onMouseLeave}
                          onMouseOver={onMouseOver}
                          onPressEnter={clickCreateContent}
                          onBlur={inputBlur}
                          onFocus={inputFocus}
                        /> */}

                        {/* 回车按钮 */}
                        {
                          // !props.runAllLoading && !util.isEmpty(x?.data?.textAreaValue) && cursorStatus ?
                          !props.runAllLoading && isFoucs[x.id] && (
                            <div
                              className={`${style["enter-bottom"]} ${isDarkMode ? style["dark-enter"] : ""}`}
                              onClick={e => onInputEnter(e, x.id)}
                            ></div>
                          )
                        }
                        {/* 删除图标 */}
                        {!props.runAllLoading &&
                        !func.isEmpty(x?.data?.textAreaValue) &&
                        !isFoucs[x.id] &&
                        !isEditPlaceholder(x.id) ? (
                          <div
                            className={`${style["close-bottom"]} ${isDarkMode ? style["dark-cross"] : ""}`}
                            onClick={e => clickCloseContent(e, x.id)}
                          ></div>
                        ) : null}

                        {props.runAllLoading && props.saasUIInputData?.length === 1 ? (
                          <div className={style["saas-loading"]}>
                            <LoadingOutline />
                          </div>
                        ) : null}

                        {/* {
                          !props.isShare ?
                            <div className={style['edit-placeholder']}>
                              <span className={`${style['edit-outline-icon']} iconfont icon-bianji`} onClick={() => openEditPlaceholder(x)}></span>
                            </div>
                          : null
                        } */}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          ) : null}
          {!showOutPut && props.saasUIInputData?.length > 1 ? (
            <div className={`${style["saas-home-bg"]} ${style["number-bg"]}`} onClick={clickTopRightNumber}>
              <span>+{props.saasUIInputData.length - 1}</span>
            </div>
          ) : null}
          {showOutPut && (isMobile || !props.isShare) ? (
            <div className={`${style["saas-home-bg"]} ${style["arrow-bg"]}`} onClick={clickArrow}>
              <UpOutlined
                style={{ fontSize: "20px", color: colorData[applicationTheme]?.topRightNumberCorlor || "#fff" }}
              />
            </div>
          ) : null}
        </div>
      )}
      <div className={style["saas-content"]} ref={contentRef}>
        {
          // output 暂时隐藏 login 等设计
          !showTopSuction && (
            <div className={style["saas-login"]}>
              <img src={login[applicationTheme]}></img>
            </div>
          )
        }
        {
          // output 暂时隐藏 SignUp 等设计
          !showTopSuction && (
            <div className={style["other-operate-box"]}>
              {props.isShare && <ToSignUpView bloc={toSignUpViewBloc}></ToSignUpView>}
            </div>
          )
        }

        {/* 操作（SaasHeadManage）与显示（SaasHeadPc） 分开 */}
        <AISaasTitle {...props} showOutPut={showTopSuction}></AISaasTitle>
        {/* 输入框 */}
        {!func.isEmpty(props.saasUIInputData) ? (
          <div className={`${style["saas-input-content"]} ${style["remove-suspension"]}`} ref={inputBoxRef}>
            {props.saasUIInputData.map((x, index) => {
              const isUploadFileInputNode =
                featureTags.disableUploadTypesAsInputNode === false && get(x, "data.displayType") === "uploadFile";
              return (
                <div key={x.id}>
                  {(!func.isEmpty(x?.data?.inputTitle) || !func.isEmpty(x?.data?.generatedLabel) || !props.isShare) && (
                    <div className={`${style["input-title-box"]}`}>
                      <PreviewTitle
                        isShare={props.isShare}
                        inputTitleId={inputTitleId}
                        onInputTitleBlur={onInputTitleBlur}
                        onInputTitleEnter={onInputTitleEnter}
                        onSaasInputTitleChange={onSaasInputTitleChange}
                        onClickInputTitleClose={onClickInputTitleClose}
                        onClickEdit={clickInputTitle}
                        showInputTitleId={showInputTitleId}
                        saasUIInputData={x}
                      />
                    </div>
                  )}
                  <div
                    className={style["transparent-storey"]}
                    onMouseLeave={onMouseLeaveBox}
                    onMouseOver={() => onMouseOverBox(x.id)}
                  >
                    <div
                      className={`${style["input-box"]} ${isFoucs[x.id] ? style["enlarge-input-box"] : ""} ${
                        isEditPlaceholder(x.id) && style["convention-padding"]
                      } ${isDarkMode ? "dark" : ""} ${isUploadFileInputNode ? style["upload-file-box"] : ""}`}
                    >
                      {!props.isShare && !showTopSuction && (
                        <div
                          className={`${onMouseInputId === x.id ? style["hover-border"] : ""} ${
                            editInputId === x.id ? style["disappears"] : ""
                          } ${isEditPlaceholder(x.id) ? style["hover-border"] : ""}
                            `}
                          onClick={e => clickEditInputId(e, x.id)}
                        >
                          {x.id === onMouseInputId && (
                            <div className={style["right-box"]}>
                              <div className={style["right-box-menu"]}>
                                <div className={style["icon-button"]} onClick={e => clickEditInputId(e, x.id)}>
                                  <img src={`${settings.S3CDN}${settings.viewAssetsPath}checkMarkBlack.png`}></img>
                                </div>
                                <div className={style["icon-button"]} onClick={e => deleteInput(e, x.id)}>
                                  <img src={`${settings.S3CDN}${settings.viewAssetsPath}previewDelete2x.png`}></img>
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      )}
                      {isUploadFileInputNode ? (
                        <Nodes
                          {...x}
                          {...x.data}
                          isInCanvas={false}
                          displayType={"uploadFile"}
                          canvasType={"saas"}
                          asInputNodeChange={value => {
                            onSaasInputChange({ target: { value } }, x.id);
                            props.clickCreateContent("saas");
                          }}
                        />
                      ) : (
                        <>
                          <Input.TextArea
                            ref={r =>
                              (inputListRef.current[index] = {
                                refKey: x.id,
                                refValue: r,
                              })
                            }
                            // ref={index === 0 ? inputTextArea : undefined}
                            placeholder={getByPlaceholderText(x, index)}
                            className={`${style["saas-input"]} ${isEditPlaceholder(x.id) && style["disappears"]}`}
                            autoSize={{ minRows: 1, maxRows: 10 }}
                            bordered={false}
                            value={x?.data?.textAreaValue}
                            disabled={props.saasUIData.staticMode}
                            onChange={e => onSaasInputChange(e, x.id)}
                            // allowClear
                            onMouseLeave={onMouseLeave}
                            onMouseOver={() => onMouseOver(x.id)}
                            // onPressEnter={(e) => e.preventDefault()}
                            onPressEnter={e => onInputEnter(e, x.id)}
                            onBlur={() => inputBlur(x.id, index)}
                            onFocus={() => inputFocus(x.id, index)}
                          />
                          {isEditPlaceholder(x.id) && (
                            <Input.TextArea
                              ref={editPlaceholderRef}
                              placeholder={editPlaceholderData?.placeholder}
                              className={`${style["saas-placeholder"]} ${style["saas-input"]}`}
                              autoSize={{ minRows: 1, maxRows: 10 }}
                              bordered={false}
                              value={editPlaceholderData?.placeholder}
                              onChange={onSaasPlaceholderChange}
                              onPressEnter={placeholderBlurEnter}
                              onBlur={() => placeholderBlurClean()}
                            />
                          )}
                        </>
                      )}

                      {/* <Input.TextArea
                          ref={inputTextArea}
                          placeholder={props.saasUIData.placeholder}
                          className={style['saas-input']}
                          autoSize={{ minRows: 1, maxRows: 10 }}
                          bordered={false}
                          value={props.saasUIInputData.data.textAreaValue}
                          onChange={onSaasInputChange}
                          // allowClear
                          onMouseLeave={onMouseLeave}
                          onMouseOver={onMouseOver}
                          onPressEnter={clickCreateContent}
                          onBlur={inputBlur}
                          onFocus={inputFocus}
                        /> */}

                      {/* 回车按钮 */}
                      {
                        // !props.runAllLoading && !util.isEmpty(x?.data?.textAreaValue) && cursorStatus ?
                        !props.runAllLoading && isFoucs[x.id] && (
                          <div
                            className={`${style["enter-bottom"]} ${isDarkMode ? style["dark-enter"] : ""}`}
                            onClick={e => onInputEnter(e, x.id)}
                          ></div>
                        )
                      }
                      {/* 删除图标 */}
                      {!props.runAllLoading &&
                      !func.isEmpty(x?.data?.textAreaValue) &&
                      !isFoucs[x.id] &&
                      !isEditPlaceholder(x.id) ? (
                        <div
                          className={`${style["close-bottom"]} ${isDarkMode ? style["dark-cross"] : ""}`}
                          onClick={e => clickCloseContent(e, x.id)}
                        ></div>
                      ) : null}

                      {props.runAllLoading && props.saasUIInputData?.length === 1 ? (
                        <div className={style["saas-loading"]}>
                          <LoadingOutline />
                        </div>
                      ) : null}

                      {/* {
                          !props.isShare ?
                            <div className={style['edit-placeholder']}>
                              <span className={`${style['edit-outline-icon']} iconfont icon-bianji`} onClick={() => openEditPlaceholder(x)}></span>
                            </div>
                          : null
                        } */}
                    </div>
                  </div>
                </div>
              );
            })}
            {props.saasUIInputData?.length > 1 ? (
              <div
                ref={btnRef}
                className={`${style["submit-button"]} ${disableButton() && style["cannot-select"]}`}
                onClick={clickSubmit}
              >
                {props.runAllLoading ? (
                  <div className={style["saas-loading"]}>
                    <LoadingOutline />
                  </div>
                ) : (
                  btnText
                )}
              </div>
            ) : null}
          </div>
        ) : null}
        <div ref={signalRef}></div>
        <div className={`${style["moddle-box"]} ${showTopSuction ? style["top-margin"] : ""}`}>
          <div className={style["max-width-box"]}>
            <div className={style["output-list"]} ref={outputListRef}>
              <AiSaasOutputList
                // stud-1046 渲染内容移动到: ItemContent
                shareBuyClassName={style["shares-buy"]}
                thoughtOptions={thoughtOptions}
                onChangeThoughts={thoughts => {
                  setDisplayThought(thoughts);
                  // 兼容老数据，更新 `SaasUIData` 数据(AiSaas)
                  props.setSaasUIData(prevData => {
                    return {
                      ...prevData,
                      output: thoughts,
                    };
                  });
                }}
              />

              {props.saasUIListData.length > 0 && (
                <div className={`${style["footer-brain-claimer"]}`}>
                  Information may be inaccurate due to its use of a General AI model.
                </div>
              )}

              <div
                className={`${style["footer-brain-studios"]} ${showBottomPrompt ? style["bottom-prompt"] : ""} ${
                  !props.runAllLoading ? style["disappears"] : ""
                }`}
              >
                {!props.runAllLoading && (
                  <div>
                    Built with <span onClick={clickBrainStudios}>Imagica</span> by Brain.ai
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style["roll-box"]} ref={rollBox}>
        <div className={style["scroll-box"]} ref={scrollBox}></div>
      </div>

      <Modal
        title="Edit placeholder"
        open={showEditPlaceholder}
        onOk={handleModalOk}
        onCancel={handleModalCancel}
        okButtonProps={{ disabled: func.isEmpty(placeholderInput) }}
      >
        <Input value={placeholderInput} onChange={handleEditplaceholderChange}></Input>
      </Modal>
    </div>
  );
}

export default React.forwardRef(AISaas);
